import { render } from "./Input.vue?vue&type=template&id=622b6062"
import script from "./Input.vue?vue&type=script&lang=js"
export * from "./Input.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eventgallery/build/tmpBuildDir/components/com_eventgallery/media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"backend/vue/imagecontentpluginform/Input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "622b6062"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('622b6062', __exports__)) {
    api.reload('622b6062', __exports__)
  }
  
  module.hot.accept("./Input.vue?vue&type=template&id=622b6062", () => {
    api.rerender('622b6062', render)
  })

}


export default __exports__